import { DragAndDrop } from '@Common/Controls';
import { Scroll } from '@View/Core/Scroll';
import { Grid } from '../SimpleGridLight';
import pointerHelper from '../../../Helpers/PointerHelper';
import { properties } from '@Common/Core/Properties';
import { GridCell } from '../GridCell';
import { IGridPlugin } from './IGridPlugin';

class GridSortablePlugin implements IGridPlugin {
    private dragRow: JQuery;
    private placeHolder: JQuery;
    private hoverRow: JQuery;
    private drag: DragAndDrop;
    private table: JQuery;
    private scroll: Scroll;
    private startIndex: number;
    private dragYoffset: number;

    constructor(
        private grid: Grid,
        private descColumn: string | number,
        private onRowMoved: (oldIndex, newIndex) => void = $.noop,
        private sortInDataSource: boolean = false,
        private isInDialog: boolean = false
    ) {
        const gridHtmlControl = grid.getControl();
        const sortContainer = $('.simpleGrid-bodyContainer', gridHtmlControl);
        this.table = $('.simpleGrid-body', gridHtmlControl);

        for (const col of grid.columns()) {
            col.isSortable(false);
        }

        this.drag = new DragAndDrop({
            dragContainment: 'parent',
            clearOnEsc: isInDialog,
            canDrag: true,
            canDrop: true,
            iScroll: this.scroll = grid.gridLayout.bodyScroller,
            showContainer: false,
            scrollArea: sortContainer,
            scopes: ['simple-grid-light']
        });

        grid.addPlugin(this);

        grid.onBeginEdit((gridCell: GridCell) => {
            const cell = gridCell.tableCell();
            cell.draggable('disable');
            if (properties.browser.mozilla) {
                // in FF after child detach parent not handle events
                cell.trigger('mouseup');
            }
        });
        grid.onEndEdit((gridCell: GridCell) => {
            gridCell.tableCell().draggable('enable');
        });
        this.drag.onDragStart(e => this.onDragStart(e));
        this.drag.onDragStop(e => this.onDragStop(e));
        this.drag.onDrag(e => this.onDrag(e));
        this.onGridChange();
    }

    public gridChange(): void {
        this.onGridChange();
    }

    private onDragStart(e) {
        const pos = pointerHelper.getPosition(e.event, this.table);
        this.dragRow = GridSortablePlugin.prepareDragRow(e.uiObjects[0]);
        this.dragYoffset = this.dragRow.actualPosition().top - pos.y;
        this.startIndex = this.dragRow.index();
        this.placeHolder = GridSortablePlugin.createPlaceHolder(this.dragRow);
        this.hoverRow = null;
        this.dragRow.hide();
        this.drag.setDragDescription(this.getRowTextIdentity());
        this.drag.toggleDragDescription(true);
    }

    private onDragStop(e) {
        GridSortablePlugin.releaseRow(this.dragRow);
        this.dragRow.insertAfter(this.placeHolder);
        this.dragRow.show();
        this.placeHolder.remove();
        const newIndex = this.dragRow.index();
        if (newIndex !== this.startIndex) {
            if (this.sortInDataSource) {
                const rc = this.grid.rowsCollection;
                rc.moveRow(this.startIndex, newIndex);
            }
            this.onRowMoved(this.startIndex, newIndex);
        }
        this.scroll.refresh();
    }

    private onDrag(e) {
        const position = pointerHelper.getPosition(e.event, this.table);
        //this.dragRow.css("top", position.y + this.dragYoffset);
        this.drag.showDragDescription();

        this.hoverRow = this.findHoverElement(position) || this.hoverRow || this.dragRow.next()[0] || this.dragRow.prev()[0] || this.dragRow;
        this.hoverRow = $(this.hoverRow);

        if (this.hoverRow.actualPosition().top + this.hoverRow.height() / 2 < position.y) {
            this.placeHolder.insertAfter(this.hoverRow);
        } else {
            this.placeHolder.insertBefore(this.hoverRow);
        }
    }

    private findHoverElement(position) {
        let row = null;
        this.table
            .children('tbody')
            .children('tr')
            .each((i, element: HTMLElement) => {
                row = $(element);
                const top = row.actualPosition().top,
                    bottom = top + row.height();
                if (element !== this.dragRow[0]) {
                    if (top <= position.y && bottom >= position.y) {
                        return false;
                    }
                }
                row = null;
            });
        return row;
    }

    private static prepareDragRow(cell: Element): JQuery<HTMLElement> {
        return $(cell).parent() as JQuery<HTMLElement>;
    }

    private static releaseRow(dragRow: JQuery) {}

    private static createPlaceHolder(row: JQuery) {
        const query = $('<tr>');
        query.addClass('drag-placeHolder');
        const ph = query.height(row.height() / 2);
        ph.insertBefore(row);
        return ph;
    }

    private getDescColumnIndex(): number {
        try {
            const column = this.grid.findColumn(this.descColumn);
            return column.columnIndex();
        } catch (e) {}

        return parseInt(this.descColumn as string, 10);
    }

    private getRowTextIdentity(): string {
        return this.dragRow.children().eq(this.getDescColumnIndex()).text();
    }

    private onGridChange() {
        const dragableObject = $('tbody td', this.table);

        this.drag.drag(dragableObject, {});
    }

    public refresh() {
        this.onGridChange();
    }
}

export interface ISortablePluginSetting {
    descColumn?: string | number;
    onRowMoved?: (oldIndex: any, newIndex: any) => void;
    sortInDataSource?: boolean;
    isInDialog?: boolean;
}

export function Sortable(params: ISortablePluginSetting): (grid: Grid) => IGridPlugin {
    return grid => new GridSortablePlugin(grid, params.descColumn, params.onRowMoved, params.sortInDataSource, params.isInDialog);
}
